
import './App.css';
import Gridd from './Components/Gridd';
import Home from './Components/Home';

function App() {
  return (
   <>
   {/* <Home/> */}
   <Gridd/>
   </>
  );
}

export default App;
